import { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { money, startCheckout, errorText } from "../lib/api";

export default function CartDrawer() {
  const { items, setQty, total, open, setOpen } = useCart();
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    setBusy(true);
    try { await startCheckout(items.map((i) => ({ lookup_key: i.id, quantity: i.qty }))); }
    catch (e) { toast.error(errorText(e)); setBusy(false); }
  };
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-[var(--paper)] w-full sm:max-w-md flex flex-col" data-testid="cart-drawer">
        <SheetHeader><SheetTitle className="f-serif text-3xl font-normal text-left">Your bag</SheetTitle></SheetHeader>
        <div className="flex-1 overflow-y-auto mt-6 divide-y rule" data-lenis-prevent>
          {items.length === 0 && <p className="text-[var(--muted)] py-10" data-testid="cart-empty">Your bag is empty.</p>}
          {items.map((i) => (
            <div key={i.id} className="flex gap-4 py-5" data-testid={`cart-item-${i.id}`}>
              <img src={i.image} alt="" className="w-16 h-20 object-cover" />
              <div className="flex-1">
                <p className="font-medium leading-snug">{i.name}</p>
                <p className="f-mono text-sm text-[var(--muted)] mt-1">{money(i.price)}</p>
                <div className="flex items-center gap-3 mt-3">
                  <button onClick={() => setQty(i.id, i.qty - 1)} className="w-7 h-7 border rule grid place-items-center" data-testid={`cart-dec-${i.id}`} aria-label="Decrease"><Minus size={13} /></button>
                  <span className="f-mono text-sm w-4 text-center">{i.qty}</span>
                  <button onClick={() => setQty(i.id, i.qty + 1)} className="w-7 h-7 border rule grid place-items-center" data-testid={`cart-inc-${i.id}`} aria-label="Increase"><Plus size={13} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-[var(--ink)] pt-5">
          <div className="flex justify-between f-serif text-2xl"><span>Subtotal</span><span data-testid="cart-total">{money(total)}</span></div>
          <p className="text-xs text-[var(--muted)] mt-1">Shipping and taxes calculated at checkout.</p>
          <button disabled={!items.length || busy} onClick={pay} className="btn-red w-full mt-5 h-12 font-semibold disabled:opacity-40" data-testid="cart-checkout-btn">
            {busy ? "Redirecting to secure checkout…" : "Checkout"}
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
